import {
  select,
} from '@ngrx/store';
import {
  selectFlowType,
  UiStatusStore,
} from '@refx/shared-store';
import {
  Observable,
} from 'rxjs';
import {
  distinctUntilChanged,
  filter,
} from 'rxjs/operators';

/**
 * Returns a method which takes the UiStatusStore in parameter and returns the flow type.
 */
export const getFlowType = () => (source: Observable<UiStatusStore>) => {
  return source.pipe(
    filter((store) => !!store.uiStatus),
    select(selectFlowType),
    distinctUntilChanged()
  );
};
